import React from 'react';
import { Badge, Box, Group, Modal, Stack, Text, UnstyledButton } from '@mantine/core';
import { IconBulb, IconChevronRight } from '@tabler/icons-react';
import type { FeatureTip } from './featureTipsCatalog';
import { isFeatureTipDismissed } from './featureTipsPreference';

export interface FeatureTipsListModalProps {
  opened: boolean;
  tips: FeatureTip[];
  onClose: () => void;
  onSelectTip: (tip: FeatureTip) => void;
}

export function FeatureTipsListModal({
  opened,
  tips,
  onClose,
  onSelectTip,
}: FeatureTipsListModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Group gap={8} wrap="nowrap" align="center">
          <IconBulb size={18} stroke={1.75} color="var(--mantine-color-brand-6)" />
          <Text fw={700} size="sm">
            Tips
          </Text>
        </Group>
      }
      centered
      size="md"
      radius="md"
      padding="lg"
    >
      <Stack gap="xs">
        <Text size="sm" c="dimmed" mb={4}>
          Short guides for new scheduling features. Open any tip to learn more.
        </Text>
        {tips.length === 0 ? (
          <Text size="sm" c="dimmed">
            No tips available yet.
          </Text>
        ) : (
          tips.map((tip) => {
            const isNew = !isFeatureTipDismissed(tip.id);
            return (
              <UnstyledButton
                key={tip.id}
                onClick={() => onSelectTip(tip)}
                style={{
                  display: 'block',
                  width: '100%',
                  padding: '10px 12px',
                  borderRadius: 8,
                  border: '1px solid var(--mantine-color-default-border)',
                  background: 'var(--mantine-color-body)',
                  textAlign: 'left',
                }}
              >
                <Group justify="space-between" wrap="nowrap" gap="sm" align="flex-start">
                  <Box style={{ minWidth: 0, flex: 1 }}>
                    <Group gap={8} wrap="nowrap" mb={4}>
                      <Text fw={600} size="sm" lineClamp={1}>
                        {tip.title}
                      </Text>
                      {isNew ? (
                        <Badge size="xs" variant="light" color="brand">
                          New
                        </Badge>
                      ) : null}
                    </Group>
                    <Text size="xs" c="dimmed" lineClamp={2}>
                      {tip.summary}
                    </Text>
                  </Box>
                  <IconChevronRight
                    size={16}
                    stroke={1.5}
                    style={{ flexShrink: 0, marginTop: 2, color: 'var(--mantine-color-dimmed)' }}
                  />
                </Group>
              </UnstyledButton>
            );
          })
        )}
      </Stack>
    </Modal>
  );
}
